<script lang="ts">
import { AppAddressFieldComponent } from "./app-address-field.ts";
export default AppAddressFieldComponent;
</script>
<template>
    <p-autocomplete
        v-bind="$attrs"
        v-model="place"
        :field="(item) => item.description"
        :suggestions="addressPredictions"
        :forceSelection="true"
        @complete="searchAddress($event)"
    />
</template>
